const styles = {
  root: {
    backgroundColor: 'background.default',
    padding: 2,
    borderRadius: 4,
  },
  iconContainer: {
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    borderRadius: 3,
    '& .MuiButton-root': {
      minWidth: 'auto!important',
    },
  },
  trashContainer: {
    backgroundColor: 'background.greyF6',
  },
  openCloseContainer: {
    backgroundColor: 'secondary.main',
    '&.delete': {
      backgroundColor: 'primary.main',
    },
    '& svg': {
      color: 'white',
    },
  },
  summary: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    '&.MuiTypography-root': {
      color: 'text.primaryDark',
    },
  },
  summaryTextContainer: {
    display: 'flex',
    alignItems: 'center',
  },
}

export default styles
